var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUpload24Px(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file_upload-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.8 19.4992C6.3 19.4992 5.875 19.3242 5.525 18.9742C5.175 18.6242 5 18.1992 5 17.6992V14.9992H6.5V17.6992C6.5 17.7659 6.53333 17.8326 6.6 17.8992C6.66667 17.9659 6.73333 17.9992 6.8 17.9992H18.2C18.2667 17.9992 18.3333 17.9659 18.4 17.8992C18.4667 17.8326 18.5 17.7659 18.5 17.6992V14.9992H20V17.6992C20 18.1992 19.825 18.6242 19.475 18.9742C19.125 19.3242 18.7 19.4992 18.2 19.4992H6.8ZM11.75 15.6242V7.22422L9.275 9.67422L8.225 8.59922L12.5 4.32422L16.775 8.59922L15.725 9.67422L13.25 7.22422V15.6242H11.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload24Px);
export default __webpack_public_path__ + "static/media/file_upload-24px.e8029b9b3b04259df5626916fe00e979.svg";
export { ForwardRef as ReactComponent };